export default __webpack_public_path__ + "static/media/dubai-airport-freezone.57d4318f.png";